import React from 'react';
import {IonModal} from '@ionic/react';
import {useLazyQuery} from '@apollo/client';

import {GET_CATEGORIES} from '../../../graphql/queries/service.query';
import {Breadcrumbs, CategoriesPopOver, Title} from '../../../components';

import '../Auto/auto.styles.css';
import ImageSVG from '../../../assets/images/attivita.svg';
import ServiceCards from '../components/Card';

const Administrative = () => {
  const [autoCategories, setAutoCategories] = React.useState([]);
  const [selectedCategoryServicesList, setSelectedCategoryServicesList] =
    React.useState<unknown[]>([]);
  const [popoverState, setShowPopover] = React.useState({
    showPopover: false,
    event: undefined,
  });
  const [selectedCategory, setSelectedCategory] = React.useState<string | null>(
    null
  );

  const [getAutoCategories] = useLazyQuery(GET_CATEGORIES, {
    variables: {
      order: 'ASC',
      field: 'name',
      offset: 0,
      limit: 100,
      paranoid: false,
      serviceType: 'administrator',
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const result: any = data?.getPaginatedCategories?.categories;

      setAutoCategories(result);
    },
  });

  React.useEffect(() => {
    getAutoCategories();
  }, []);

  const breadcrumbEntries = [
    {title: 'Servizi', link: '/servizi'},
    {title: 'Pratiche amministrative'},
  ];

  const handleItemClick = (e: any, category: any) => {
    e.persist();
    setSelectedCategory(category.name);

    setSelectedCategoryServicesList(
      [
        category?.services
          ?.filter((item: any) => item.isFeatured)
          ?.sort((a: any, b: any) =>
            a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : 0
          ),
        category?.services
          ?.filter((item: any) => !item.isFeatured)
          ?.sort((a: any, b: any) =>
            a.name.toLowerCase() < b.name.toLowerCase()
              ? -1
              : a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : 0
          ),
      ].flat()
    );
    setShowPopover({showPopover: true, event: undefined});
  };

  return (
    <div className='app-container'>
      <Breadcrumbs items={breadcrumbEntries} />

      <Title>
        <span className='service-title'>Pratiche amministrative</span>
      </Title>

      <div className='app-page-wrapper grid-items-4x'>
        {autoCategories?.map((category: any, index: number) => (
          <ServiceCards
            key={index}
            title={category.name}
            image={ImageSVG}
            onClick={(e: any) => handleItemClick(e, category)}
          />
        ))}
      </div>

      <IonModal
        cssClass='auto-height-search'
        isOpen={popoverState.showPopover}
        onDidDismiss={() =>
          setShowPopover({showPopover: false, event: undefined})
        }
      >
        <CategoriesPopOver
          arrayList={selectedCategoryServicesList}
          selectedCategory={selectedCategory}
          onDismiss={() =>
            setShowPopover({showPopover: false, event: undefined})
          }
        />
      </IonModal>
    </div>
  );
};

export default Administrative;
